<template>
  <div>
    <autoLogout />
    <loader :loader="loader" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-container>
            <validation-observer v-slot="{ invalid }">
              <v-form id="newDate" lazy-validation v-model="valid" ref="form">
                <v-row class="mb-2" justify="center" v-if="objAddDate && objAddDate.idPatient">
                  <v-col cols="12" md="12" sm="12">
                    <patient-information :model="objAddDate" />
                  </v-col>
                  <!-- <validation-provider name="Paciente" v-slot="{ errors }" rules="required">
                      <v-autocomplete v-model="objAddDate.idPatient" :value="objAddDate.idPatient"
                        :disabled="withPatient" :items="patientList" :item-text="patientList.text"
                        :item-value="patientList.value" :error-messages="errors" label="Paciente"
                        prepend-icon="mdi-account" required no-data-text="Sin pacientes por mostrar"
                        @change="(check = false), resetValues()" clearable></v-autocomplete>
                    </validation-provider> -->

                  <v-col justify="center">
                    <v-radio-group v-model="objAddDate.serviceType" :disabled="check" row
                      label="¿Es un seguimiento a una cita previa?:" mandatory>
                      <v-radio label="No" value="1"></v-radio>
                      <v-radio value="2" label="Sí" @click="listClinicalEventByPatient()"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row v-if="objAddDate.serviceType === '2'">
                  <v-col class="col-md-4">
                    <validation-provider name="Evento clínico" v-slot="{ errors }" rules="required">
                      <v-autocomplete v-model="objAddDate.idClinicalEvent" :items="clinicalEventList"
                        :item-text="clinicalEventList.text" :item-value="clinicalEventList.value"
                        :error-messages="errors" prepend-icon="mdi-stethoscope" label="Evento clínico"
                        no-data-text="Sin eventos clínicos por mostrar" clearable @change="setPresuntiveDiag()"
                        required></v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row justify="center" class="mt-2 mb-2">
                  <v-col cols="3" sm="12" md="2" lg="3">
                    <v-switch v-model="referringPhysicianSwitch" label="Médico referido" color="success"></v-switch>
                  </v-col>
                </v-row>
                <div v-if="referringPhysicianSwitch">
                  <v-row>
                    <v-col>
                      <h3 class="font-weight-black mb-5">
                        Médico referido
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <validation-provider v-slot="{ touched, invalid, errors }" name="Título académico"
                        rules="required|max:20|min:1|regex:^[a-zA-ZÀ-ÿ ]+\.?$">
                        <v-text-field :error-messages="errors" label="Título académico" required clearable dense
                          :clear-icon="$cnst.CLEAR_ICON" prepend-icon="mdi-folder-account" :counter="20" :maxlength="20"
                          v-model="referringPhysician.academicTitle">
                          <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
                            {{ touched && invalid ? "mdi-alert" : "" }}
                          </v-icon>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <!-- rules="required|max:60|min:2|nameWithDot" -->

                      <validation-provider v-slot="{ touched, invalid, errors }" name="Nombre"
                        rules="required|max:60|min:2">
                        <v-text-field :error-messages="errors" label="Nombre(s)*" required clearable dense
                          :clear-icon="$cnst.CLEAR_ICON" prepend-icon="mdi-account" :counter="60" :maxlength="60"
                          v-model="referringPhysician.name">
                          <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
                            {{ touched && invalid ? "mdi-alert" : "" }}
                          </v-icon>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider v-slot="{ touched, invalid, errors }" name="Primer apellido"
                        rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$">
                        <v-text-field :error-messages="errors" label="Primer apellido" required clearable dense
                          :clear-icon="$cnst.CLEAR_ICON" prepend-icon="mdi-card-account-details" :counter="60"
                          :maxlength="60" v-model="referringPhysician.firstLastname">
                          <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
                            {{ touched && invalid ? "mdi-alert" : "" }}
                          </v-icon>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider v-slot="{ invalid, errors, touched }" name="Segundo apellido"
                        rules="max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$">
                        <v-text-field :error-messages="errors" label="Segundo apellido" clearable dense
                          :clear-icon="$cnst.CLEAR_ICON" prepend-icon="mdi-card-account-details-outline" :counter="60"
                          :maxlength="60" v-model="referringPhysician.secondLastname">
                          <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
                            {{ touched && invalid ? "mdi-alert" : "" }}
                          </v-icon>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </div>
                <v-divider class="mt-4"></v-divider>
                <v-row class="mt-4">
                  <v-col>
                    <h3 class="font-weight-black mb-5">
                      Información de cita
                    </h3>
                  </v-col>
                </v-row>
                <v-row class="mb-2" justify="center" align="center">
                  <v-col md="2" sm="12" class="text-center">
                    <h3 class="mb-2 ml-4"><strong> {{ $utilFront.formatTimeClock(date) }}</strong></h3>
                    <validation-provider name="Fecha cita" rules="required">
                      <vc-date-picker :max-date="new Date()" color="green" v-model="date" mode="date" is24hr
                        :disabled-dates='{}'>
                        <!-- <template v-slot="{ inputValue, inputEvents }">
                          <div class="flex justify-center items-center">
                            <v-text-field :value="inputValue" label="Fecha Cita" v-on="inputEvents" :disabled="true">
                              <v-icon slot="append" :color="valid ? 'success' : ''">
                                {{ valid ? " mdi-check" : "" }}
                              </v-icon></v-text-field>
                          </div>
                        </template> -->
                      </vc-date-picker>
                    </validation-provider>
                  </v-col>
                  <v-col md="10" sm="12">
                    <v-row justify="center" align="center" dense>
                      <v-col md="4" sm="12" justify="center" align="center">
                        
                        <validation-provider v-slot="{ errors }" name="Especialidad" rules="required">
                          <v-autocomplete  v-model="objAddDate.speciality"
                            label="Especialidad" no-data-text="Sin especialidades por mostrar" :items="specialityList"
                            item-text="name" item-value="idSpeciality" :error-messages="errors" required return-object
                            @change="checkbutton();checkSpecialityWithModal();"/>
                        </validation-provider>
                      </v-col>
                    
                        <v-col md="4" sm="12"  justify="center" align="center" v-if="objAddDate.speciality.idSpeciality == 3 || objAddDate.speciality.idSpeciality == 2">
                          <validation-provider v-slot="{ errors }" name="Modalidad" rules="required">
                            <v-autocomplete prepend-icon="mdi-radiology-box" v-model="objAddDate.idModality"
                              label="Modalidad" no-data-text="Sin modalidad por mostrar" :items="modalityList"
                              item-text="name" item-value="idModality" :error-messages="errors" required @change="unfill = true;fillStudyProfile();"/>
                          </validation-provider>
                        </v-col>

                        <v-col md="4" sm="12"  justify="center" align="center" v-if="objAddDate.speciality.idSpeciality == 3 || objAddDate.speciality.idSpeciality == 2">
                          <validation-provider v-slot="{ errors }" name="Perfil de estudio" rules="required">
                            <v-autocomplete prepend-icon="mdi mdi-file-alert-outline"
                              v-model="objAddDate.idStudyModality" label="Perfil de estudio"
                              no-data-text="Sin modalidad por mostrar" :items="labStudyProfileList" item-text="name"
                              item-value="idStudyModality" :error-messages="errors" required return-object
                              @change="unfill = false"></v-autocomplete>
                          </validation-provider>
                        </v-col>
                      
                      
                    </v-row>
                    <v-row  dense>
                      <v-col md="12" sm="12"  align="center">
                        <v-btn variant="tonal" color="primary" @click="addAppointment()" :disabled="unfill">
                           <v-icon  >mdi-plus</v-icon>
                          </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>



                  <v-container>
                    <template v-if="appointmentsList.length > 0">
                      <v-row>
                        <v-col cols="12" md="12" sm="12">
                          <AppointmentsTablexUser :appointmentsList="appointmentsList"
                            :deleteAppointment="deleteAppointment" :objAddDate="objAddDate" />
                        </v-col>
                      </v-row>
                    </template>
                  </v-container>
                  <v-col v-if="$utilFront.nonLite()">
                    <validation-provider v-slot="{ errors }" name="Turno" rules="required">
                      <v-select v-model="objAddDate.turn" :items="turnList" :item-text="turnList.text"
                        :item-value="turnList.value" :error-messages="errors" prepend-icon="mdi-timer-sand"
                        label="Turno" no-data-text="Sin turnos por mostrar" required></v-select>
                    </validation-provider>
                  </v-col>
                </v-row>
                <div v-if="$utilFront.nonLite()">
                  <v-divider></v-divider>
                  <v-subheader class="mb-2">Información de envio</v-subheader>
                  <v-row class="mb-2">
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Motivo de envío" rules="required">
                        <v-autocomplete v-model="objAddDate.type" label="Motivo de envío" prepend-icon="mdi-help"
                          :items="reasonsList" :item-text="reasonsList.text" :item-value="reasonsList.value"
                          :error-messages="errors" no-data-text="Sin resultados por mostrar" required
                          clearable></v-autocomplete>
                      </validation-provider>
                    </v-col>

                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Diagnóstico presuntivo"
                        rules="required|regex:^[a-zA-ZÀ-ÿ0-9 ]">
                        <v-textarea v-model="objAddDate.reason" rows="1" label="Diagnóstico presuntivo"
                          prepend-icon="mdi-pencil" no-data-text="Sin resultados por mostrar" :error-messages="errors"
                          required clearable></v-textarea>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="$utilFront.nonLite()">
                  <v-divider></v-divider>
                  <v-subheader class="mb-2">Información de destino</v-subheader>
                  <v-row class="mb-2">
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Clave presupuestal envío" rules="required">
                        <v-autocomplete v-model="objAddDate.idBranchOfficeDestination" :items="branchOffList"
                          :item-text="branchOffList.text" :item-value="branchOffList.value" :error-messages="errors"
                          no-data-text="Sin sucursales por mostrar" prepend-icon="mdi-hospital-building"
                          label="Clave presupuestal envío" required :disabled="disBranch" @change="
      listAllConsultingRoomsDestination(
        objAddDate.idBranchOfficeDestination
      )
      " clearable></v-autocomplete>
                      </validation-provider>
                    </v-col>

                    <v-col>
                      <validation-provider v-slot="{ errors }" :name="`${label}`" rules="required">
                        <v-autocomplete v-model="objAddDate.consultingRoomDestination"
                          :items="consultingRoomsDestination" :item-text="consultingRoomsDestination.text"
                          :item-value="consultingRoomsDestination.value" :error-messages="errors"
                          :disabled="selectedBrDes" prepend-icon="mdi-hospital-marker" :label="`${label} de destino`"
                          no-data-text="Sin consultorios por mostrar" required @change="fullHumanDes = false"
                          clearable></v-autocomplete>
                      </validation-provider>
                    </v-col>

                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Doctor de atención" rules="required">
                        <v-autocomplete v-model="objAddDate.humanResourceDestination" :items="humanResourceList"
                          :item-text="humanResourceList.text" :item-value="humanResourceList.value"
                          :error-messages="errors" :disabled="fullHumanDes" prepend-icon="mdi-doctor"
                          label="Doctor de atención" no-data-text="Sin doctores por mostrar" required
                          clearable></v-autocomplete>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </div>
                <template v-if="flagSave == true">
                  <AppointmentSometryModal :addDate="addDate" :dialogAppointment="dialogAppointment"
                    @changeSometometry="changeSometometry" @dialogClose="dialogClose" />
                </template>

                <v-row>
                  <v-col class="d-flex justify-space-around">
                    <v-btn color="error" plain class="mb-4" @click="$router.go(-1)">Cancelar<v-icon
                        right>mdi-close</v-icon>
                    </v-btn>
                     <v-btn
                  class="primary mb-4"
                  @click="onGenerateClick()"
                  :disabled="sending || invalid || unsave"
                >
                  Generar cita(s)
                  <v-icon right>mdi-book-clock</v-icon>
                </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </validation-observer>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";
import AppointmentsTablexUser from "@/components/appointments/AppointmentsTablexUser.vue";
import AppointmentSometryModal from "@/components/appointments/AppointmentSometryModal.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("regex", {
  ...regex,
  message: "{_field_} no debe contener caracteres especiales o espacios",
});

import {
  MedicalPracticeRequest,
  PatientRequest,
  StudyRequest,
  EnumRequest,
  ConsultingRoomRequest,
  BranchOfficeRequest,
  HumanResourceRequest,
  ClinicalEventRequest,
  ModaltyRequest,
  StudyModalityRequest,
  SpecialityRequest,
  ReportPDFRequest,
} from "@/core/request";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../components/Sidebar.vue";
import moment from "moment";
import Loader from "../components/Loader.vue";
import { mapActions } from "vuex";
import AutoLogout from "../components/AutoLogout.vue";
let token = localStorage.getItem("token");

export default {
  components: {
    Sidebar,
    Encabezado,
    Loader,
    AutoLogout,
    ValidationObserver,
    ValidationProvider,
    AppointmentsTablexUser,
    AppointmentSometryModal,
    PatientInformation
  },
  name: "CrearCita",
  data: () => ({
    loader: false,
    label: "Consultorio",
    valid: false,
    today: "",
    fullHuman: true,
    fullHumanDes: true,
    selectedBrOr: true,
    selectedBrDes: true,
    selectedPro: true,
    selectedMod: true,
    check: true,
    eventType: 0,
    nameRules: [(v) => !!v || "Campo requerido"],
    encabezado: { icono: "mdi-calendar", texto: "Nueva cita" },
    date2: null,
    menu2: false,
    activePicker: null,
    objAddDate: {
      serviceType: 1,
      speciality: {
        idSpeciality: 0,
      },
    },
    patientList: [],
    branchOffList: [],
    humanResourceList: [],
    clinicalEventList: [],
    specialitiesList: [],
    reasonsList: [],
    eventsType: [],
    turnList: [
      { text: "Matutino", value: 1 },
      { text: "Vespertino", value: 2 },
      { text: "Nocturno", value: 3 },
      { text: "Mixto", value: 4 },
    ],
    consultingRoomsOrigin: [],
    consultingRoomsDestination: [],
    modaltiesList: [],
    prioritiesList: [],
    profileStudiesList: [],
    idHumanResource: "",
    date: new Date(),
    dateFormatted: null,
    menu1: false,
    invalidDate: false,
    listTurns: [],
    profStudy: false,
    showInput: false,
    disBranch: true,
    withPatient: false,
    sending: false,
    /******************************** */
    /*Registro citas */
    sometriaChoose: true,
    specialityList: [],
    modalityListRequest: [],
    studyProfileList: [],
    minDateTime: null,
    modalityList: [],
    labModalityList: [],
    imgModalityList: [],
    labStudyProfileList: [],
    imgStudyProfileList: [],
    appointmentsList: [],
    unfill: true,
    dialogAppointment: false,
    flagModal: false,
    flagSave: false,
    appointmentData: {},
    unsave: true,
    referringPhysician: {
      academicTitle: "",
      name: "",
      firstLastname: "",
      secondLastname: "",
    },
    referringPhysicianSwitch: false,
    hasPendingSelection: false,
  }),
  created() {
    this.validBrowserTab();
    this.listAllBranchOffice();
    this.getPatients();
    this.listAllSpeciality();
    this.listAllReasons();
    //this.listAllHumanResources();
    this.listPriority();
    let minDate = new Date();
    this.today = moment(minDate).format("YYYY-MM-DD HH:mm:ss");
    this.getIdPatient();
    this.getTurns();
    /***@MaudePallares **/
    this.listAppointment();
    this.minDateTime = this.$utilFront.getCurrentDateTime();
    this.date = new Date();
    setInterval(() => {
      this.date = new Date();
    }, 1000);
  },

  computed: {
    // computedDateFormatted() {
    //   return this.formatDate(this.date);
    // },
  },

  watch: {
    // date(val) {
    //   try {
    //     this.dateFormatted = this.formatDate(this.date);
    //     let result = moment(
    //       this.dateFormatted,
    //       "DD/MM/YYYY hh:mm a",
    //       true
    //     ).isValid();
    //     if (result) {
    //       this.invalidDate = false;
    //       document.getElementById("fechaNac").style.color = "";
    //     } else {
    //       this.invalidDate = true;
    //     }

    //     const day = moment(new Date(this.date))
    //       .locale("es-mx")
    //       .format("dddd");

    //     const infoByDay = this.listTurns.filter(
    //       (t) => t.dayText.toLowerCase() == day.toLowerCase()
    //     );

    //     const hours = moment(new Date(val)).format("HH");

    //     infoByDay.find((i) => {
    //       const hoursStart = moment(
    //         new Date(`2021-08-13T${i.startTime}`)
    //       ).format("HH");
    //       const hoursEnd = moment(new Date(`2021-08-13T${i.endTime}`)).format(
    //         "HH"
    //       );
    //       if (hours >= hoursStart && hours <= hoursEnd) {
    //         this.objAddDate.turn = i.turn;
    //         return true;
    //       }
    //     });
    //   } catch (e) {
    //     this.invalidDate = true;
    //   }
    // },

    // "objAddDate.idModality": function (val) {
    //   if (val.text.includes("CE - Consulta Externa")) {
    //     this.showInput = false;
    //     this.objAddDate.idStudyModality = "";
    //   } else {
    //     this.showInput = true;
    //   }
    //   this.disBranch = false;

    // },
    appointmentsList: function () {
      if (this.appointmentsList.length > 0) {
        this.unsave = false;
      } else {
        this.unsave = true;
      }
    },

    'objAddDate.speciality'(val) {
    this.hasPendingSelection = !!val.idSpeciality
  },
  'objAddDate.idModality'(val) {
    if (val) this.hasPendingSelection = true
  },
  'objAddDate.idStudyModality'(val) {
    if (val && val.idStudyModality) this.hasPendingSelection = true
  },
  appointmentsList() {
    this.unsave = this.appointmentsList.length === 0
  },
  },

  methods: {
    ...mapActions(["validTab", "unauthorized"]),

    /**************************************************************** */
    /*** Funciones agregar cita ***/
    /***@MaudePallares ***/
    changeSometometry(e) {
      this.sometriaChoose = e;
    },
    dialogClose(e) {
      this.dialogAppointment = e;
    },
    listAppointment() {
  ModaltyRequest.allModality().then((res) => {
    let modality = res.data.data;
    this.modalityListRequest = modality.filter(
      (item) => item.name !== 'PAPANICOLAOU' && item.name !== 'COLPOSCOPIA'
    );
  });

  SpecialityRequest.allSpeciality().then((res) => {
    let specialties = res.data.data;
    this.specialityList = specialties.filter(
      (item) => item.name !== 'PAPANICOLAOU' && item.name !== 'COLPOSCOPIA' && item.name !== 'TELEMEDICINA'
    );
  });

  StudyModalityRequest.allStudyModality().then((res) => {
    let studyprofile = res.data.data;
    this.studyProfileList = studyprofile.filter(
      (item) => item.name !== 'PAPANICOLAOU' && item.name !== 'COLPOSCOPIA'
    );
  });
},

    checkSpecialityWithModal() {
      if (
        this.objAddDate.speciality.idSpeciality == 2 ||
        this.objAddDate.speciality.idSpeciality == 3
      ) {
        this.fillModality();
      } else {
        return;
      }
    },
    fillModality() {
      let labModality = [];
      let imgModality = [];
      if (this.objAddDate.speciality.idSpeciality == 3) {
        this.modalityList = [];
        for (let h in this.modalityListRequest) {
          if (
            this.modalityListRequest[h].speciality.idSpeciality ==
            this.objAddDate.speciality.idSpeciality
          ) {
            labModality = this.modalityListRequest[h];
            this.labModalityList.push(labModality);
          }
          this.modalityList = this.labModalityList;
        }
      } else if (this.objAddDate.speciality.idSpeciality == 2) {
        this.modalityList = [];
        for (let h in this.modalityListRequest) {
          if (
            this.modalityListRequest[h].speciality.idSpeciality ==
            this.objAddDate.speciality.idSpeciality
          ) {
            imgModality = this.modalityListRequest[h];
            this.imgModalityList.push(imgModality);
          }
        }
        this.modalityList = this.imgModalityList;
      }
      this.fillStudyProfile();
    },
    fillStudyProfile() {
      let labStudyProfile = [];
      this.labStudyProfileList = [];
      for (let h in this.studyProfileList) {
        if (
          this.studyProfileList[h].modality.idModality ==
          this.objAddDate.idModality
        ) {
          labStudyProfile = this.studyProfileList[h];
          this.labStudyProfileList.push(labStudyProfile);
        }
      }
    },
    checkbutton() {
      if (
        this.objAddDate.speciality.idSpeciality == 2 ||
        this.objAddDate.speciality.idSpeciality == 3
      ) {
        this.unfill = true;
      } else {
        this.unfill = false;
      }
    },
    addAppointment() {
      if (
        this.objAddDate.speciality.idSpeciality == 2 ||
        this.objAddDate.speciality.idSpeciality == 3
      ) {
        let appointment = {
          date: this.date,
          speciality: {
            idSpeciality: this.objAddDate.speciality.idSpeciality,
            name: this.objAddDate.speciality.name,
          },
          modality: {
            idModality: this.objAddDate.idModality,
            name: this.objAddDate.idStudyModality.modality.name,
          },
          studyProfile: {
            idStudyProfile: this.objAddDate.idStudyModality.idStudyModality,
            name: this.objAddDate.idStudyModality.name,
          },
        };
        this.appointmentData = appointment;
        // this.appointmentsList.push(this.appointmentData);
        //   this.clearAppointments();
        if (this.appointmentsList.length == 0) {
          this.appointmentsList.push(this.appointmentData);
          this.clearAppointments();
        } else if (this.appointmentsList.length > 0) {
          this.validateDoubleAppointment();
          this.clearAppointments();
        }
      } else {
        let appointment = {
          date: this.date,
          speciality: {
            idSpeciality: this.objAddDate.speciality.idSpeciality,
            name: this.objAddDate.speciality.name,
          },
          modality: {
            idModality: "",
            name: "-",
          },
          studyProfile: {
            idStudyProfile: "",
            name: "-",
          },
        };
        this.appointmentData = appointment;
        // this.appointmentsList.push(this.appointmentData);
        //   this.clearAppointments();
        if (this.appointmentsList.length == 0) {
          this.appointmentsList.push(this.appointmentData);
          this.clearAppointments();
        } else if (this.appointmentsList.length > 0) {
          this.validateAppointmentWithoutModality();
          this.clearAppointments();
        }
      }
      this.clearAppointments();
      this.hasPendingSelection = false
    },
    clearAppointments() {
      this.appointmentData = {};
      this.unfill = true;
      this.objAddDate.speciality = {};
      this.objAddDate.idModality = "";
      this.objAddDate.idStudyModality = {};
      this.hasPendingSelection = false
    },
    onGenerateClick() {
    // Para una especialidad repetida en la tabla y luego que está en el dropdown pero no agendada
    this.checkbutton()
    if (this.hasPendingSelection) {
      return this.$utilFront.notifications(
        "Completa la cita o limpia los campos antes de generar.",
        "ERROR"
      )
    }
    // Faltan modalidad/perfil en lab/img
    if (this.unfill) {
      return this.$utilFront.notifications(
        "Rellena modalidad y perfil antes de generar.",
        "ERROR"
      )
    }
    // nNo hay NINGUNA cita añadida
    if (this.appointmentsList.length === 0) {
      return this.$utilFront.notifications(
        "Agrega al menos una cita antes de continuar.",
        "ERROR"
      )
    }
    // Al final se abre el modal
    this.dialogAppointment = true
    this.flagSave = true
  },
    deleteAppointment(index) {
      this.flagSave = false;
      this.appointmentsList.splice(index, 1);
    },
    validateDoubleAppointment() {
      let flag = false;
      for (let p = 0; p < this.appointmentsList.length; p++) {
        if (
          this.appointmentsList[p].studyProfile.idStudyProfile ==
          this.appointmentData.studyProfile.idStudyProfile
        ) {
          flag = true;
        }
      }
      if (flag) {
        this.$utilFront.notifications(
          "Cita ya registrada, no se puede registrar dos veces",
          "ERROR"
        );
      } else {
        this.appointmentsList.push(this.appointmentData);
      }
    },
    validateAppointmentWithoutModality() {
      let flag = false;
      for (let p = 0; p < this.appointmentsList.length; p++) {
        if (
          this.appointmentsList[p].speciality.idSpeciality ==
          this.appointmentData.speciality.idSpeciality
        ) {
          flag = true;
        }
      }
      if (flag) {
        this.$utilFront.notifications(
          "Cita ya registrada, no se puede registrar dos veces",
          "ERROR"
        );
      } else {
        this.appointmentsList.push(this.appointmentData);
      }
    },
    /***************************************************************************************** */
    validBrowserTab() {
      this.validTab();
    },
    getTurns() {
      const idBranchOffice = this.$utilFront.getIdBranchOffice();
      BranchOfficeRequest.listHoursByBranchOffice({ idBranchOffice }).then(
        (res) => {
          if (res.data.code === 200) {
            this.listTurns = res.data.data.listBranchOfficeHours.map(
              (turno) => {
                return {
                  day: turno.day,
                  dayText: turno.dayText,
                  turn: turno.turn,
                  turnText: turno.turnText,
                  startTime: turno.startTime,
                  endTime: turno.endTime,
                };
              }
            );
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }
      );
    },
    getIdPatient() {
      if (this.$route.params.idPatient) {
        this.objAddDate.idPatient = this.$route.params.idPatient;
        this.withPatient = true;
      }
    },
    // formatDate(date) {
    //   if (!date) return null;

    //   const [date1, hour, type] = date.split(" ");
    //   const [year, month, day] = date1.split("-");
    //   const [h, m] = hour.split(":");
    //   return `${day}/${month}/${year} ${h}:${m} ${type}`;
    // },
    // parseDate(date) {
    //   if (!date) return null;

    //   const [date1, hour, type] = date.split(" ");
    //   const [day, month, year] = date1.split("/");
    //   const [h, m] = hour.split(":");
    //   return `${year}-${month.padStart(2, "0")}-${day.padStart(
    //     2,
    //     "0"
    //   )} ${h}:${m} ${type}`;
    // },
    validate() {
      return this.$refs.form.validate();
    },
    saveNac(date2) {
      this.$refs.menu2.save(date2);
    },

    listClinicalEventByPatient() {
      let idPatient = this.objAddDate.idPatient;
      let eventText = "";
      ClinicalEventRequest.listClinicalEventByPatient(
        { idPatient: idPatient },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          try {
            this.clinicalEventList = res.data.data.map((event) => {
              if (event.eventType === 1) {
                eventText = "Consulta";
              } else if (event.eventType === 2) {
                eventText = "Estudio imagen";
              } else if (event.eventType === 3) {
                eventText = "Estudio laboratorio";
              } else if (event.eventType === 4) {
                eventText = "Dental";
              }

              let text =
                eventText +
                " - " +
                event.idClinicalEvent +
                " | " +
                this.$utilFront.formatDateTime(event.registrationDate);
              return { text: text, value: event.idClinicalEvent };
            });
          } catch (e) {
            this.$utilFront.notifications(res.data.data, "WARNING");
            this.objAddDate.serviceType = 1;
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllHumanResources(idBranch) {
      HumanResourceRequest.listHumanResourcesByType({
        idBranchOffice: idBranch,
      }).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data) {
            this.humanResourceList = res.data.data.map((human) => {
              let fullNameHuman = `${human.person.name} ${human.person.firstLastname} ${human.person.secondLastname} - (${human.personalType.name})`;

              fullNameHuman = fullNameHuman
                .replace("null", "")
                .replace("  ", " ");

              return {
                text: fullNameHuman,
                value: human.idHumanResource,
              };
            });
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          this.humanResourceList = [];
        }
      });
    },
    listAllBranchOffice() {
      BranchOfficeRequest.listAllBranchOffice({
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data) {
            this.branchOffList = res.data.data.map((branch) => {
              let branchOffName =
                branch.name + " " + "(" + branch.idBranchOffice + ")";
              return {
                text: branchOffName,
                value: branch.idBranchOffice,
              };
            });
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    getPatients() {
      // let data = {
      //   idBranchOffice:
      //     this.idBranchOfficeSelected != null
      //       ? this.idBranchOfficeSelected
      //       : "",
      //   start: null,
      //   end: null,
      //   statusUserList: [],
      // };
      // PatientRequest.listPatientsByDate(data).then((res) => {
      //   this.loader = false;
      //   if (res.data.code === 200 && res.data.status === "OK") {
      //     let fPatients = res.data.data.filter(
      //       (fPatient) => fPatient.status === 1
      //     );
      //     this.patientList = fPatients.map((patient) => {
      //       return {
      //         value: patient.idPatient,
      //         text: patient.fullName,
      //       };
      //     });
      //   } else if (res.data.code === 401) {
      //     this.unauthorized();
      //   }
      // });
    },
    listAllSpeciality() {
      SpecialityRequest.allSpeciality().then((res) => {
        let { code, data, status } = res.data;
        if (code === 200 && status === "OK") {
          this.specialitiesList = data
            .map((speciality) => {
              return { text: speciality.name, value: speciality.idSpeciality };
            })
            .filter((speciality) => {
              return speciality.value === 1; //Solo mostrar consulta
            });
        }
      });
    },
    listAllReasons() {
      EnumRequest.listAllAppointmentType({
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          if (res.data.data) {
            this.reasonsList = res.data.data.map((reason) => {
              return {
                text: reason.text,
                value: reason.value,
              };
            });
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllConsultingRoomsOrigin() {
      ConsultingRoomRequest.listAllConsultingRoomByBranchOffice(
        {
          branchOffice: {
            idBranchOffice: this.objAddDate.idBranchOfficeOrigin,
          },
        },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          if (res.data.data) {
            this.consultingRoomsOrigin = res.data.data.map((room) => {
              return {
                text: room.name,
                value: room.idConsultingRoom,
              };
            });
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllConsultingRoomsDestination(idBranchOffice) {
      let idModality = this.objAddDate.idModality.value;

      if (idBranchOffice && idModality) {
        let dataPost = {
          idModality: idModality,
          idBranchOffice: idBranchOffice,
        };

        ConsultingRoomRequest.listAllConsultingRoomByModalty(dataPost, {
          headers: { Authorization: token },
        }).then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.consultingRoomsDestination = res.data.data.map((room) => {
              return {
                text: room.name,
                value: room.idConsultingRoom,
              };
            });
            this.selectedBrDes = false;
            this.listAllHumanResources(idBranchOffice);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(res.data.data, "WARNING");
            this.selectedBrDes = false;
            this.consultingRoomsDestination = [];
            this.humanResourceList = [];
          }
        });
      }
    },
    listPriority() {
      EnumRequest.listAllStudyPriority({
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.prioritiesList = res.data.data.map((priority) => {
            return {
              text: priority.text,
              value: priority.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    addDate() {
      let clearAppointments = this.appointmentsList.map(function (
        appointmentitem
      ) {
        let clearAppointments = {
          dateAppointment: appointmentitem.date,
          speciality: appointmentitem.speciality.idSpeciality,
          modality: appointmentitem.modality.idModality,
          studyProfile: appointmentitem.studyProfile.idStudyProfile,
        };
        return clearAppointments;
      });
      if (!this.sending) {
        this.sending = true;

        let objDate = this.objAddDate;

        let endTime = moment(this.date, "YYYY-MM-DD hh:mm a")
          .add(15, "m")
          .toDate();

        let startTime = moment(this.date, "YYYY-MM-DD hh:mm a").format();

        if (this.validate()) {
          let data = {
            withSomatometry: this.sometriaChoose,
            appointmentList: clearAppointments,
            idBranchOfficeOrigin: this.$utilFront.getIdBranchOffice(),
            idHumanResource: this.$utilFront.getIdHumanResource(),
            idPatient: objDate.idPatient,
            referringPhysician: (this.referringPhysicianSwitch ? this.referringPhysician : null),
            // appointment: {
            //   reason: objDate.reason,
            //   type: objDate.type,
            //   startTime: clearAppointments.dateAppointment,
            //   endTime: moment(new Date(endTime)).format(),
            //   turn: objDate.turn,
            //   serviceType: objDate.serviceType,
            //   speciality: clearAppointments.speciality,
            //   clinicalEvent: {},
            //   consultingRoomDestination: {
            //     idConsultingRoom: objDate.consultingRoomDestination,
            //   },
            //   humanResourceOrigin: {
            //     idHumanResource: this.$utilFront.getIdHumanResource(),
            //   },
            //   humanResourceDestination: {
            //     idHumanResource: objDate.humanResourceDestination,
            //   },
            // },
          };
          StudyRequest.addStudy(data)
            .then((res) => {
              let { message, response } = res.data;
              if (response === true) {
                this.$router.go(-1);

                if (this.$utilFront.nonEmptyList(data?.appointmentList)) {
                  let dateAppointment =
                    data?.appointmentList[0]?.dateAppointment;
                  let dataReport = {
                    idPatient: data.idPatient,
                    registrationDate: dateAppointment,
                  };
                  ReportPDFRequest.downloadOrderStudyReception(dataReport).then(
                    (response) => {
                      this.$utilFront.openPDF(response.data);
                    }
                  );
                }
                this.$utilFront.notifications("Cita registrada", "SUCCESS");
              } else {
                this.$utilFront.notifications(
                  message || "Cita no registrada, error interno",
                  "ERROR"
                );
              }
            })
            .finally(() => {
              this.sending = false;
            });
          // if (objDate.serviceType === "1") {
          //   // Cita sin evento clinico
          //   data.appointment.clinicalEvent = {
          //     eventType: objDate.type,
          //     patient: { idPatient: objDate.idPatient },
          //   };
          // } else {
          //   // Cita con evento clinico
          //   data.appointment.clinicalEvent = {
          //     idClinicalEvent: objDate.idClinicalEvent,
          //   };
          // }

          // if (objDate.speciality === 1 || objDate.speciality === 4) {
          // Registro de consulta

          // data.idBranchOffice = this.$utilFront.getIdBranchOffice();

          // MedicalPracticeRequest.addMedicalPractice(data)
          //   .then((res) => {
          //     let { code, data, status } = res.data;
          //     if (code === 200 && status === "OK") {
          //       this.$router.go(-1);
          //       this.$utilFront.notifications("Cita registrada", "SUCCESS");
          //     } else {
          //       this.$utilFront.notifications(
          //         "Cita no registrada, error interno",
          //         "ERROR"
          //       );
          //     }
          //   })
          //   .finally(() => {
          //     this.sending = false;
          //   });
          //   } else {
          //      Registro de Estudio

          //      data.priorityStudy = 1;
          //      data.studyModality = { idStudyModality: objDate.idStudyModality };
          //      data.idBranchOfficeOrigin = this.$utilFront.getIdBranchOffice();

          //     StudyRequest.addStudy(data)
          //       .then((res) => {
          //         let { code, data, status } = res.data;
          //         if (code === 200 && status === "OK") {
          //           this.$router.go(-1);
          //           this.$utilFront.notifications("Cita registrada", "SUCCESS");
          //         } else {
          //           this.$utilFront.notifications(
          //             "Cita no registrada, error interno",
          //             "ERROR"
          //           );
          //         }
          //       })
          //       .finally(() => {
          //         this.sending = false;
          //       });
          //   }
          // } else {
          //   this.$utilFront.notifications(
          //     "Sucedio un error al registrar cita",
          //     "ERROR"
          //   );
          this.sending = false;
          this.loader = false;
        }
      }
    },
    setPresuntiveDiag() {
      if (this.objAddDate.idClinicalEvent) {
        this.objAddDate.reason = `Seguimiento a ${this.objAddDate.idClinicalEvent}`;
      }
    },
    checkStudyProfile(Modality) {
      if (Modality[0].text === "CE - Consulta Externa") {
        this.profStudy = true;
        this.selectedPro = true;
      } else {
        this.selectedPro = false;
      }
    },
    resetValues() {
      this.objAddDate.serviceType = "1";
      this.objAddDate.reason = "";
      this.objAddDate.idClinicalEvent = "";
    },
  },
};
</script>
